import "jquery";
import { __ } from "@wordpress/i18n";

export const $ = window.jQuery;

export const ADMIN_URL = window.antimanual?.admin_url || "";
export const AJAX_URL = window.antimanual?.ajax_url || "";
export const REST_URL = window.antimanual?.rest_url || "";
export const IS_PUBLIC_SITE = Boolean(window.antimanual?.is_public_site);
export const HAS_EAZYDOCS_PRO = Boolean(window.antimanual?.has_eazydocs_pro);
export const IS_PRO = Boolean(window.antimanual?.is_pro);
export const PRICING_DETAILS_URL = window.antimanual?.pricing_details_url || "";
export const BUY_PRO_URL = window.antimanual?.buy_pro_url || "";

export const NONCE = {
    DOC_OUTLINE: window.antimanual?.nonce.doc_outline || "",
    GENERATE_DOC: window.antimanual?.nonce.generate_doc || "",
    AI_RESPONSE_TO_TOPIC: window.antimanual?.nonce.ai_response_to_topic || "",
    AI_RESPONSE_TO_REPLY: window.antimanual?.nonce.ai_response_to_reply || "",
    TOPIC_RESPONSE_PREFERENCES: window.antimanual?.nonce.topic_response_preferences || "",
    GET_POSTS_BY_TYPE: window.antimanual?.nonce.get_posts_by_type || "",
    GET_PARENT_POSTS: window.antimanual?.nonce.get_parent_posts || "",
    GET_EXCERPT: window.antimanual?.nonce.get_excerpt || "",
    SET_TERMS: window.antimanual?.nonce.set_terms || "",
    GET_TAXONOMY_TERMS: window.antimanual?.nonce.get_taxonomy_terms || "",
    SET_TAXONOMY_TERMS: window.antimanual?.nonce.set_taxonomy_terms || "",
    CONVERT_TOPIC: window.antimanual?.nonce.convert_topic || "",
};

export const AJAX_ACTION = {
    DOC_OUTLINE: "antimanual_doc_outline",
    GENERATE_DOC: "antimanual_generate_doc",
    AI_RESPONSE_TO_TOPIC: "antimanual_response_to_topic",
    AI_RESPONSE_TO_REPLY: "antimanual_response_to_reply",
    TOPIC_RESPONSE_PREFERENCES: "antimanual_topic_response_preferences",
    GET_POSTS_BY_TYPE: "antimanual_get_posts_by_type",
    GET_PARENT_POSTS: "antimanual_get_parent_posts",
    GET_EXCERPT: "antimanual_get_excerpt",
    SET_TERMS: "antimanual_set_terms",
    GET_TAXONOMY_TERMS: "antimanual_get_taxonomy_terms",
    SET_TAXONOMY_TERMS: "antimanual_set_taxonomy_terms",
    CONVERT_TOPIC: "antimanual_convert_topic",
};

export const OPENAI = {
    HAS_KEY: Boolean(window.antimanual?.openai?.has_key),
    MASKED_KEY: window.antimanual?.openai?.masked_key || "",
    MODEL: window.antimanual?.openai?.model || "gpt-5-nano",
    EMBEDDING_MODEL: window.antimanual?.openai?.embedding_model || "text-embedding-ada-002",
    CHAT_MODELS: window.antimanual?.openai?.chat_models || [],
    EMBEDDING_MODELS: window.antimanual?.openai?.embedding_models || [],
}

export const GEMINI = {
    HAS_KEY: Boolean(window.antimanual?.gemini?.has_key),
    MASKED_KEY: window.antimanual?.gemini?.masked_key || "",
    MODEL: window.antimanual?.gemini?.model || "gemini-3-flash-preview",
    EMBEDDING_MODEL: window.antimanual?.gemini?.embedding_model || "text-embedding-004",
    CHAT_MODELS: window.antimanual?.gemini?.chat_models || [],
    EMBEDDING_MODELS: window.antimanual?.gemini?.embedding_models || [],
}

export const LAST_ACTIVE_PROVIDER = window.antimanual?.last_active_provider || 'openai';

export const CHAT_CONFIG = {
    enabled: window.antimanual?.chatbot?.config.enabled,
    merge_ezd: window.antimanual?.chatbot?.config.merge_ezd,
    label: window.antimanual?.chatbot?.config.label,
    position: window.antimanual?.chatbot?.config.position,
    primary_color: window.antimanual?.chatbot?.config.primary_color,
    bg_color: window.antimanual?.chatbot?.config.bg_color,
    title: window.antimanual?.chatbot?.config.title,
    help_text: window.antimanual?.chatbot?.config.help_text,
    wlc_msg: window.antimanual?.chatbot?.config.wlc_msg,
    icon: window.antimanual?.chatbot?.config.icon,
    btn_txt: window.antimanual?.chatbot?.config.btn_txt,
    prebuilt_1: window.antimanual?.chatbot?.config.prebuilt_1,
    prebuilt_2: window.antimanual?.chatbot?.config.prebuilt_2,
    prebuilt_3: window.antimanual?.chatbot?.config.prebuilt_3,
    irrelevant_ans: window.antimanual?.chatbot?.config.irrelevant_ans,
};

export const CHATBOT_ICONS = window.antimanual?.chatbot?.icons || [];
export const CHATBOT_POSITIONS = [
    { value: "after-tabs", label: __("After Tabs", "antimanual") },
    { value: "before-tabs", label: __("Before Tabs", "antimanual") },
];

export const TOPIC_CONTEXT = {
    TOPIC_ID: window.antimanual?.topic_context?.topic_id || 0,
    TOPIC_TITLE: window.antimanual?.topic_context?.topic_title || "",
    THREAD: window.antimanual?.topic_context?.thread || "",
};

export const USERS =
    window.antimanual?.users?.map((user) => ({
        id: user.ID,
        name: user.display_name,
        username: user.user_login,
    })) || [];

export const POST_TYPES =
    window.antimanual?.post_types?.map((postType) => ({
        id: postType.name,
        label: postType.label,
        hasEditor: postType.has_editor,
        isHierarchical: postType.hierarchical,
        supportsExcerpt: postType.supports.includes("excerpt"),
        taxonomies: postType.taxonomies.map((taxonomy) => ({
            id: taxonomy.name,
            label: taxonomy.label,
            labels: taxonomy.labels,
        })),
    })) || [];

export const OPTIONS = {
    AI_RESPONSE_TO_TOPIC: window.antimanual?.options.ai_response_to_topic || false,
    AI_RESPONSE_TO_REPLY: window.antimanual?.options.ai_response_to_reply || false,
    AI_RESPONSE_AS_REPLY: window.antimanual?.options.ai_response_as_reply || false,
    AI_RESPONSE_NOTICE:
        window.antimanual?.options.ai_response_notice ||
        __(
            `While we’ve trained the system with extensive internal knowledge, documentation, and best practices to ensure high accuracy, please note that AI-generated content may not always be fully accurate or reflect the most up-to-date information. We strongly encourage users to verify critical information and seek human expertise when needed.`,
            "antimanual"
        ),
    AI_AUTHOR_ID: `${window.antimanual?.options.ai_author_id || USERS?.[0]?.id || 0}`,
    AI_REPLY_MIN_WORDS: window.antimanual?.options.ai_reply_min_words || 10,
    EXCLUDED_ROLES: (window.antimanual?.options.excluded_roles || []) as string[],
    PAGINATION_LIMIT: 20,
};

// Current user info (frontend only - for AI response filtering)
export const CURRENT_USER = {
    ID: window.antimanual?.current_user?.id || 0,
    ROLES: (window.antimanual?.current_user?.roles || []) as string[],
};

// AI Author ID from settings (frontend only - for AI response filtering)
export const AI_AUTHOR_ID = window.antimanual?.ai_author_id || 0;

// Excluded roles from AI response modal (frontend only)
export const EXCLUDED_ROLES = (window.antimanual?.excluded_roles || []) as string[];

// Available roles for admin settings
export const AVAILABLE_ROLES = (window.antimanual?.available_roles || []) as { value: string; label: string }[];

export const LS = {
    DOC_OUTLINE: "antimanual_doc_outline",
    DOC_PROMPT: "antimanual_doc_prompt",
    DOC_PREFERENCES: "antimanual_doc_preferences",
};

export const ENUM = {
    AUTO: "auto",
    CUSTOM: "custom",
    AI_RESPONSE_TO_TOPIC: "antimanual_response_to_topic",
    AI_RESPONSE_TO_REPLY: "antimanual_response_to_reply",
    AI_RESPONSE_AS_REPLY: "antimanual_response_as_reply",
    AI_RESPONSE_NOTICE: "antimanual_response_disclaimer",
    AI_AUTHOR_ID: "antimanual_author_id",
    AI_REPLY_MIN_WORDS: "antimanual_reply_min_words",
    AI_EXCLUDED_ROLES: "antimanual_excluded_roles",
    POST_TYPE: {
        POST: "post",
        PAGE: "page",
        FORUM: "forum",
        TOPIC: "topic",
        REPLY: "reply",
        DOCS: "docs",
        ONE_PAGE_DOCS: "onepage-docs",
    },
    POST_STATUS: {
        DRAFT: "draft",
        PUBLISH: "publish",
        PRIVATE: "private",
        CLOSED: "closed",
    },
};

export const INPUT = {
    ANTIMANUAL_RESPONSE_HELPED: { NAME: "antimanual_response_helped", VALUE: "1" },
    ANTIMANUAL_RESPONSE: { NAME: "antimanual_response" },
    BBP_TOPIC_STATUS: { NAME: "bbp_topic_status", VALUE: ENUM.POST_STATUS.CLOSED },
    OVERWRITE_EXISTING_EXCERPTS: { NAME: "overwrite_existing_excerpts" },
    OVERWRITE: { NAME: "overwrite" },
    EXCERPT_LENGTH: { NAME: "excerpt_length", MIN: 10, MAX: 200, DEFAULT: 50 },
    NUMBER_OF_TERMS: { NAME: "number_of_terms", MIN: 1, MAX: 10, DEFAULT: 5 },
    TERMS_THRESHOLD: { NAME: "terms_threshold", MIN: 0, MAX: 100, DEFAULT: 5 },
};

export const DEFAULTS = {
    LESSONS_COUNT: 5,
    SUB_LESSONS_COUNT: 4,
    SLUG_LEN: 5,
    POST_STATUS: ENUM.POST_STATUS.PUBLISH,
    LANGUAGE: "en",
    TONE: "professional",
};

export const LIMITS = {
    KB_WP_POSTS: 100,
    AUTO_POSTING: 2,
    DOCS_LESSONS_COUNT: 10,
    DOCS_SUB_LESSONS_COUNT: 10,
    CHATBOT_MONTHLY: 60,
    BULK_REWRITE_MONTHLY: 100,
    FORUM_CONVERSION_MONTHLY: 100,
    FORUM_ANSWER_MONTHLY: 100,
    SEARCH_BLOCK: 100,
};

export const AUTO_OR_CUSTOM_OPTIONS = [
    { label: __("Auto", "antimanual"), value: ENUM.AUTO },
    { label: __("Custom", "antimanual"), value: ENUM.CUSTOM },
];

export const POST_STATUSES = [
    { label: __("Draft", "antimanual"), value: ENUM.POST_STATUS.DRAFT },
    { label: __("Published", "antimanual"), value: ENUM.POST_STATUS.PUBLISH },
    { label: __("Private", "antimanual"), value: ENUM.POST_STATUS.PRIVATE },
];

export const WEEKDAYS = [
    {
        value: 0,
        label: __("Sunday", "antimanual"),
        shortLabel: __("Sun", "antimanual"),
    },
    {
        value: 1,
        label: __("Monday", "antimanual"),
        shortLabel: __("Mon", "antimanual"),
    },
    {
        value: 2,
        label: __("Tuesday", "antimanual"),
        shortLabel: __("Tue", "antimanual"),
    },
    {
        value: 3,
        label: __("Wednesday", "antimanual"),
        shortLabel: __("Wed", "antimanual"),
    },
    {
        value: 4,
        label: __("Thursday", "antimanual"),
        shortLabel: __("Thu", "antimanual"),
    },
    {
        value: 5,
        label: __("Friday", "antimanual"),
        shortLabel: __("Fri", "antimanual"),
    },
    {
        value: 6,
        label: __("Saturday", "antimanual"),
        shortLabel: __("Sat", "antimanual"),
    },
];
